import { ConsentId } from '@/shared/enums';
import { Deferred } from '@/shared/libs';

const TcfEventStatus = {
  TC_LOADED: 'tcloaded',
  USER_ACTION_COMPLETE: 'useractioncomplete',
};

export default class OneTrust {
  constructor() {
    this.activeGroups = [ConsentId.STRICTLY_NECESSARY, ConsentId.IPRESSO, ConsentId.SENTRY, ConsentId.CAPTCHA].join(',');
  }

  get acceptedConsents() {
    return this.activeGroups.split(',').filter(Boolean);
  }

  init() {
    if (!window.OneTrust) {
      return Promise.resolve();
    }

    this.tcfDeffered = new Deferred();

    window.OneTrust.OnConsentChanged(() => this.onConsentChanged());
    window.__tcfapi('addEventListener', 2, (tcData, success) => this.onTcfChanged(tcData, success));

    this.activeGroups = window.OnetrustActiveGroups;

    return this.tcfDeffered.promise;
  }

  onConsentChanged() {
    if (this.activeGroups !== window.OnetrustActiveGroups) {
      window.location.reload();
    }
  }

  onTcfChanged(tcData, success) {
    if (!success) {
      this.tcfDeffered.reject();
    }

    if (tcData.eventStatus === TcfEventStatus.TC_LOADED) {
      this.gdprApplies = tcData.gdprApplies ? 1 : 0;
      this.gdprConsent = tcData.tcString;
      this.tcfDeffered.resolve();
    }

    if (tcData.eventStatus === TcfEventStatus.USER_ACTION_COMPLETE && this.gdprConsent !== tcData.tcString) {
      window.location.reload();
    }
  }

  areConsentsAccepted(consentIds = []) {
    return consentIds.length && consentIds.every((consentId) => this.acceptedConsents.includes(consentId));
  }

  changeLanguage(lang) {
    if (!window.OneTrust) {
      return;
    }

    window.OneTrust.changeLanguage(lang);
  }

  open() {
    if (!window.OneTrust) {
      return;
    }

    window.OneTrust.ToggleInfoDisplay();
  }

  close() {
    if (!window.OneTrust) {
      return;
    }

    window.OneTrust.Close();
  }
}
